import React from 'react';

const HasAccess = props => {
  const { children, access } = props;
  return access && <> {children} </>;
};

export default HasAccess;
